<template>
    <div>
        <div v-if="presetData.panel">
            <h1>{{presetData.abnormality == "" ? "N" : "Abn"}}ormal Panel Preset</h1>
            <div v-if="presetData.abnormality" style="font-size: 115%; margin-bottom: 6px;">
                <b>Abnormality:</b> {{presetData.abnormality}}
            </div>
            <a :href="'/settings/panel_presets?presetID=' + presetData.id" target="_blank" 
            v-if="presetData.pid == $store.state.jwtClaims.pid" style="color: black; font-weight: bold;">
                &lt;&lt; Edit Preset
            </a>
            <div>
                <Vote refType="panel_preset" :refID=presetID @notify="notify"/>
            </div>
            <hr>
            <PanelViewer :panel="presetData.panel" :panelIndex="1" complete panelPurchased/>
        </div>
        <center v-else>
            <md-progress-spinner :md-diameter="60" :md-stroke="10" md-mode="indeterminate">
            </md-progress-spinner>
        </center>
        <!-- Notification Snackbar -->
		<md-snackbar md-position="left" :md-duration="notificationDuration" :md-active.sync="showNotification">
			<span>{{notificationContents}}</span>
			<md-button class="md-primary" @click="showNotification=false">X</md-button>
		</md-snackbar>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import Vote from "../Vote.vue"
    import PanelViewer from "./PanelViewer.vue"

    export default {
        props: {
            presetID: {
                type: String
            }
        },
        data: function () {
            return {
                presetData: {},
                reviewData: {},
                showNotification: false,
                notificationDuration: 2500,
				notificationContents: "",
            }
        },
        components: {
            Vote,
            PanelViewer,
        },
        methods: {
            loadPresetData: function () {
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + this.presetID
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if (!data) data = {}
                    this.presetData = data
                })
            },
            duplicatePreset: function(){
                let confirm_msg = "Are you sure you want to duplicate this panel preset?"
                if(!confirm(confirm_msg)) return
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + this.presetID + "/duplicate"
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if(!data) data = {}
                    if(!data.presetID) throw "Missing preset ID in response from server"
                    alert("Preset duplicated sucessfully. If a new tab does not appear with the newly duplicated preset, please disable your popup blocker for this website.")
                    var win = window.open("/settings/panel_presets?presetID=" + data.presetID, '_blank');
                    win.focus();
                    this.$emit("fetchPanelPresets")
                    this.closePresetEditor()
                }).catch(() => {
                    this.$emit("notify", "Failed to duplicate panel preset.")
                })
                this.closePresetEditor()
            },
            notify: function(notificationContents, notificationDuration=2500){
				this.notificationContents = notificationContents;
				this.showNotification = true;
				this.notificationDuration = notificationDuration;
			},
        },
        mounted: function () {
            this.$nextTick(function () {
                this.loadPresetData()
            })
        }
    }
</script>

<style scoped>
    .md-dialog:not(.vertical-layout){
        max-width: 96vw !important;
        width: 96vw;
        max-height: 100vh !important;
    }
</style>